<script setup lang="ts">
import { object, string } from 'yup'

const emit = defineEmits<{ (e: 'submitted'): void }>()

const client = useStrapi()

const schema = object({
  email: string()
    .email('Please enter a valid email address')
    .required('An email address is required to join the list')
})

const state = reactive({
  email: '',
  loading: false
})

const toast = useToast()

async function onSubmit() {
  try {
    // TODO: Update language based on locale
    state.loading = true
    await client.fetch('subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: state.email,
        attributes: { language: 'EN' }
      })
    })

    toast.add({
      title: 'Subscription Confirmed',
      description:
        "Thank you for joining. We'll be in touch with exclusive updates.",
      color: 'success',
      icon: 'i-heroicons-check-circle'
    })
    state.email = ''
    emit('submitted')
  } catch (error) {
    toast.add({
      title: 'Error',
      description: 'Something went wrong...',
      color: 'error',
      icon: 'i-heroicons-exclamation-circle'
    })
  } finally {
    state.loading = false
  }
}
</script>

<template>
  <UForm :schema="schema" :state="state" @submit="onSubmit" class="space-y-6">
    <UFormField name="email" class="text-left">
      <UInput
        v-model="state.email"
        type="email"
        color="neutral"
        variant="outline"
        placeholder="Enter your email address"
        class="w-full"
      >
        <template #leading>
          <UIcon name="i-heroicons-envelope" class="w-6 h-6 text-dimmed" />
        </template>
      </UInput>
    </UFormField>

    <UButton type="submit" color="primary" block :loading="state.loading">
      Subscribe
    </UButton>
  </UForm>
</template>
